<template>
  <div id="test-done">
    <div class="backdrop">
      <div class="img-container">
        <img src="../../assets/bg-test.png" :style=setPos alt="">
      </div>
    </div>
    <comp-header
      :headerPosition="headerPos"
      :pageTitle="headerPageTitle"
    />
    <div class="done-wrapper">
      <div class="done-container">
        <i class="fas fa-check-circle" style="font-size: 5em"></i>
        <p><strong style="margin-bottom: 1em;">{{ $t('test.done.content') }}</strong></p>
      </div>
    </div>
    <div class="absolute-bottom">
      <form-button
        :btnName="buttonName"
        @parentCall="completedTest"
      />
    </div>
    <comp-moadl
      v-if="friendsModal"
      @confirm="goPage"
    >
      <p slot="body">{{ friendsModalBody }}</p>
    </comp-moadl>
  </div>
</template>

<script>
import CompHeader from '@/components/CompHeader';
import FormButton from '@/components/FormButton';
import CompMoadl from '@/components/CompModal';

export default {
  name: 'test-done',
  data() {
    return {
      headerPos: 'on-top',
      headerPageTitle: this.$i18n.t('test.done.header'),

      buttonName: this.$i18n.t('test.done.button'),

      friendsModalBody: '',
      friendsModal: false,

      docHeight: window.innerHeight,
      docWidth: window.innerWidth,
    };
  },
  components: {
    CompHeader,
    FormButton,
    CompMoadl,
  },
  methods: {
    completedTest() {
      // Check add friends available
      const friendSeqId = Object.prototype.hasOwnProperty.call(localStorage, 'shareUserSeqId') ?
        localStorage.getItem('shareUserSeqId') :
        localStorage.getItem('addUserSeqId');

      // eslint-disable-next-line
      if (friendSeqId && this.$store.getters.getUserSeqId != friendSeqId) {
        this.$store.dispatch('addFriend', { friendSeqId })
          .then(({ status, error }) => {
            if (status === 500) {
              this.friendsModalBody = '한명이 문제를 다 풀지 않았습니다.';
              this.friendsModal = true;
            } else if (status === 400 && error.resultCode === -200) {
              this.friendsModalBody = error.resultMsg;
              this.friendsModal = true;
            } else if (status === 400 && error.resultCode === -300) {
              this.friendsModalBody = error.resultMsg;
              this.friendsModal = true;
            } else {
              this.friendsModalBody = this.$i18n.t('mc6.friends.done');
              this.friendsModal = true;
            }
          });
      } else {
        this.goPage('/mc6');
      }
    },
    goPage() {
      this.friendsModal = false;
      if (Object.prototype.hasOwnProperty.call(localStorage, 'addUserSeqId')) {
        this.$router.push('/match/list');
      } else {
        this.$router.push('/mc6');
      }
      localStorage.removeItem('shareUserSeqId');
      localStorage.removeItem('addUserSeqId');
    },
    handleResize() {
      this.docHeight = window.innerHeight;
      this.docWidth = window.innerWidth;
    },
  },
  computed: {
    setPos() {
      const docHeight = this.docHeight;
      const docWidth = this.docWidth;
      let marginValue = '';
      if (docHeight > docWidth) {
        const marginCal = (docHeight - docWidth) / 2;
        marginValue = `-${marginCal}px`;
        return {
          'margin-left': marginValue,
          width: 'auto',
          height: '100%',
        };
      }
      if (docHeight < docWidth) {
        const marginCal = (docWidth - docHeight) / 2;
        marginValue = `-${marginCal}px`;
        return {
          'margin-top': marginValue,
          width: '100%',
          height: 'auto',
        };
      }
      return {
        width: '100%',
        height: 'auto',
      };
    },
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
};
</script>

<style lang="scss" src="../../scss/acc-done.scss" sceoped></style>



// WEBPACK FOOTER //
// src/views/test/test-done.vue